var exports = {
  "Y": "x31de4314--461d90--tooltip",
};

module.exports = exports;
